import React from "react";
import { YourIdeasContainer, YourIdeasText } from "./YourIdeasSection.styled";
import { Highlight } from "components/Hightlight/Hightlight.style";
import { Trans } from "react-i18next";

import ActionButton from "components/Button/ActionButton/ActionButton";
import { ReactComponent as ButtonIcon } from "assets/images/svg/arr-right.svg";
import useDevice from "hooks/useDevice";
import { PropTypes } from "prop-types";

const YourIdeasSection = ({ textColor }) => {
  const { isMobile } = useDevice();
  return (
    <YourIdeasContainer $textColor={textColor}>
      <YourIdeasText>
        <Trans
          i18nKey="ourWorkPage.yourIdeas.text"
          components={[<Highlight color="thertiary" key={0} isText={true} />]}
        />
      </YourIdeasText>
      <ActionButton
        size={"md"}
        isLink={true}
        marginTop={"0px"}
        maxWidth={"379px"}
        width={!isMobile ? "379px" : "144px"}
        height={!isMobile ? "120px" : "51px"}
        padding={!isMobile ? "38px 44px" : "19px 22px"}
        font={!isMobile ? "24px" : "11px"}
        iconSize={"8.7px"}
      >
        <Trans i18nKey="ourWorkPage.yourIdeas.hireUs" />
        <ButtonIcon></ButtonIcon>
      </ActionButton>
    </YourIdeasContainer>
  );
};
YourIdeasSection.propTypes = {
  textColor: PropTypes.string,
};
YourIdeasSection.defaultProps = {};
export default YourIdeasSection;
